import { render, staticRenderFns } from "./edit-message-modal.vue?vue&type=template&id=0cf33f94&"
import script from "./edit-message-modal.vue?vue&type=script&lang=js&"
export * from "./edit-message-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports